import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import authReducer from './slices/authSlice';
import employerReducer from './slices/employerSlice';
import candidateReducer from './slices/candidateSlice';
import interviewReducer from './slices/interviewSlice';
import uiReducer from './slices/uiSlice';
import videoCallReducer from './slices/videoCallSlice';
import screenRecordingReducer from './slices/screenRecordingSlice';
import instantInterviewReducer from './slices/instantInterviewSlice';
import interviewResultsReducer from './slices/interviewResultsSlice';

import feedbackReducer from './slices/feedbackSlice';
import codingRoundReducer from './slices/codingRoundSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    employer: employerReducer,
    candidate: candidateReducer,
    interview: interviewReducer,
    interviewResults: interviewResultsReducer,
    feedback: feedbackReducer,
    ui: uiReducer,
    videoCall: videoCallReducer,
    screenRecording: screenRecordingReducer,
    instantInterview: instantInterviewReducer,
    codingRound: codingRoundReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
